/* jshint esversion: 6 */
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import { showToast } from "../../showTost";
import V1CashfreeCheckout from "../../Payment/V1CashfreeCheckout";

function formatDateLabel(value) {
  const s = String(value).slice(0, 10);
  const [y, m, d] = s.split("-").map(Number);
  if (!y) return s;
  return new Date(y, m - 1, d).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" });
}

export default function LabTestsCheckout() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [cart, setCart] = useState([]);
  const [slot, setSlot] = useState(null);
  const [address, setAddress] = useState("Home, Hyderabad");
  const [ready, setReady] = useState(false);
  const [onlineFlow, setOnlineFlow] = useState(false);

  useEffect(() => {
    try {
      const c = JSON.parse(sessionStorage.getItem("lab_tests_cart") || "[]");
      if (!c.length) {
        navigate("/lab-tests", { replace: true });
        return;
      }
      setCart(c);

      const fromState = location.state?.slot;
      const fromStore = JSON.parse(sessionStorage.getItem("lab_slot") || "null");
      const s = fromState || (fromStore && fromStore.phlebotomist_id ? fromStore : null);

      if (!s) {
        showToast({ title: "Choose a collection slot first", id: "warning" });
        navigate("/lab-tests/slots", { replace: true });
        return;
      }
      sessionStorage.setItem("lab_slot", JSON.stringify(s));
      setSlot(s);
      setReady(true);
    } catch (_) {
      navigate("/lab-tests", { replace: true });
    }
  }, [location.state, navigate]);

  if (!ready) {
    return (
      <div className="width-container py-16 text-center text-gray-500">
        Loading checkout…
      </div>
    );
  }

  const estTotal = cart.reduce((s, c) => s + Number(c.price || 0), 0);

  const startOnline = () => {
    const uid = secureLocalStorage.getItem("Userid");
    if (!uid) {
      setIsLoginShow(true);
      showToast({ title: "Please log in to complete booking", id: "warning" });
      return;
    }
    if (!slot) {
      navigate("/lab-tests/slots", { replace: true });
      return;
    }
    setOnlineFlow(true);
  };

  const createOnlineCheckout = async () => {
    const uid = secureLocalStorage.getItem("Userid");
    const res = await axios.post(`${ApiBaseUrl}/api/v1/lab/bookings/checkout`, {
      id: uid,
      tests: cart.map((c) => ({ test_id: c.test_id, quantity: 1 })),
      appointment_date: slot.appointment_date,
      appointment_slot: slot.appointment_slot,
      phlebotomist_id: slot.phlebotomist_id,
      collection_location: { latitude: 17.385, longitude: 78.4867, address },
    });
    if (!res.data.success) throw new Error(res.data.error_message || "Checkout failed");
    const c = res.data.checkout;
    return { payment_session_id: c.payment_session_id, cashfree_order_id: c.cashfree_order_id, ref: c.booking_reference, environment: c.environment };
  };

  const confirmOnline = async ({ cashfree_order_id, ref }) => {
    const uid = secureLocalStorage.getItem("Userid");
    const res = await axios.post(`${ApiBaseUrl}/api/v1/lab/bookings/${ref}/confirm`, {
      id: uid,
      cashfree_order_id,
    });
    if (!res.data.success) throw new Error(res.data.error_message || "Confirmation failed");
    return res.data;
  };

  const onlineSuccess = (ref) => {
    sessionStorage.removeItem("lab_tests_cart");
    sessionStorage.removeItem("lab_slot");
    showToast({ title: "Booking confirmed", id: "success" });
    navigate(`/lab-tests/track/${ref}`, { replace: true });
  };

  return (
    <div className="width-container py-8 pb-12">
      <Link to="/lab-tests/slots" className="text-sm text-rm-primary underline mb-4 inline-block">← Change slot</Link>
      <h1 className="text-2xl font-bold mb-4">Confirm lab booking</h1>
      <div className="bg-white border rounded-xl p-4 mb-4">
        <h3 className="font-semibold mb-2">Tests</h3>
        <ul className="space-y-1">{cart.map((c) => <li key={c.test_id} className="text-sm">{c.name} — ₹{c.price}</li>)}</ul>
      </div>
      <div className="bg-teal-50 border border-teal-100 rounded-xl p-4 mb-4 text-sm">
        <p><strong>Phlebotomist:</strong> {slot.phlebotomist_name}</p>
        <p><strong>Date:</strong> {formatDateLabel(slot.appointment_date)}</p>
        <p><strong>Time:</strong> {String(slot.appointment_slot).replace("-", "–")}</p>
      </div>
      <label className="block text-sm font-medium mb-1">Home collection address</label>
      <textarea className="w-full border rounded-lg p-3 mb-4" rows={3} value={address} onChange={(e) => setAddress(e.target.value)} />
      <p className="text-sm text-gray-600 mb-4">Complete payment to confirm your booking.</p>
      {!onlineFlow ? (
        <button type="button" className="rm-btn-primary w-full py-3 text-base font-semibold" onClick={startOnline}>
          Continue to payment
        </button>
      ) : (
        <V1CashfreeCheckout
          amount={estTotal || "—"}
          createCheckout={createOnlineCheckout}
          confirmPayment={confirmOnline}
          onSuccess={onlineSuccess}
          onCancel={() => setOnlineFlow(false)}
        />
      )}
    </div>
  );
}
